import {POPULAR_DOMAINS_URL} from '../constants';
import {PopularDomainsWorkerResponse} from '../typings';
import {useFetchWorker} from './use-fetch-worker';

export const usePopularDomain = () => {
  return useFetchWorker<PopularDomainsWorkerResponse>(POPULAR_DOMAINS_URL);
};
